import {BaseMobxStore} from "../../infrastructure/mobx/base-mobx-store";
import {PropositionBetsWidgetState} from "./models/proposition-bets-widget.state";
import {PropositionBetsWidgetConfig} from "./proposition-bets-widget.config";

export class PropositionBetsWidgetStore extends BaseMobxStore {
  static injectables = [PropositionBetsWidgetConfig, PropositionBetsWidgetState];
}

